import React, { memo, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Modal, ModalWrapper } from '@workboard/wobo-ui';
import { useTranslation } from 'react-i18next';

/**
 * Chart 'View data' modal.
 */
const HiddenChart = styled('div')``;
const StyledModal = styled(Modal)`
  ${ModalWrapper} {
    min-width: 500px;

    ${HiddenChart} {
      display: none;
    }
  }
`;
const ChartDataModal = (props) => {
  useEffect(() => {
    if (props.showModal) {
      setTimeout(() => {
        props.callBackHandler?.('graph-table-view-id');
      })
    }
  });
  const { t } = useTranslation();
  return (
    <StyledModal
      title={t('View as table')}
      isOpen={props.showModal}
      onDismiss={() =>props.setShowModal(false)}
      onSubmit={() => props.setShowModal(false)}
      submitLabel={t('Close')}
      submitOnly
      data-testid="modal-view-as-table"
      enableScrollContent
    >
      {props.children ?? <HiddenChart id="graph-table-view-id" />}
    </StyledModal>
  );
}

// Set default props
ChartDataModal.defaultProps = {
 
};

export default memo(ChartDataModal);
